import { useEffect, useRef } from "react";

export default function LatticeCanvas() {
  const canvasRef = useRef(null);
  const mouse = useRef({ x: 0.5, y: 0.5 });

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    let raf;
    let t = 0;

    const resize = () => {
      canvas.width = canvas.offsetWidth * window.devicePixelRatio;
      canvas.height = canvas.offsetHeight * window.devicePixelRatio;
    };
    resize();
    window.addEventListener("resize", resize);

    const onMouse = (e) => {
      mouse.current = { x: e.clientX / window.innerWidth, y: e.clientY / window.innerHeight };
    };
    window.addEventListener("mousemove", onMouse);

    const draw = () => {
      t += 0.003;
      const w = canvas.width;
      const h = canvas.height;
      ctx.clearRect(0, 0, w, h);

      const gap = Math.max(w / 26, 60);
      const px = (mouse.current.x - 0.5) * 30 * window.devicePixelRatio;
      const py = (mouse.current.y - 0.5) * 30 * window.devicePixelRatio;

      for (let depth = 0; depth < 3; depth++) {
        const scale = 1 + depth * 0.55;
        const offsetX = px * scale;
        const offsetY = py * scale;
        const alpha = 0.05 - depth * 0.013;
        ctx.strokeStyle = `rgba(197, 160, 89, ${alpha})`;
        ctx.lineWidth = window.devicePixelRatio * 0.6;

        for (let x = -gap; x < w + gap; x += gap * scale) {
          ctx.beginPath();
          ctx.moveTo(x + offsetX + Math.sin(t + depth) * 12, -gap);
          ctx.lineTo(x + offsetX + Math.cos(t * 0.7 + depth) * 12, h + gap);
          ctx.stroke();
        }
        for (let y = -gap; y < h + gap; y += gap * scale) {
          ctx.beginPath();
          ctx.moveTo(-gap, y + offsetY + Math.cos(t + depth) * 12);
          ctx.lineTo(w + gap, y + offsetY + Math.sin(t * 0.8 + depth) * 12);
          ctx.stroke();
        }
      }
      raf = requestAnimationFrame(draw);
    };
    raf = requestAnimationFrame(draw);

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
      window.removeEventListener("mousemove", onMouse);
    };
  }, []);

  return <canvas ref={canvasRef} data-testid="hero-lattice-canvas" className="absolute inset-0 w-full h-full" aria-hidden="true" />;
}
